import { BackButton } from 'components/button/button.styled'
import { CurrentPartner } from 'components/currentPartner'
import React from 'react'

import { ButtonWrapper, Container, FormContainer, FormContainerWrapper } from './formWrapper.style'

interface FormWrapperProps {
    onClose?: () => void
    children: React.ReactNode
    partnerName?: string
}

export const FormWrapper: React.FC<FormWrapperProps> = ({ onClose, children, partnerName }) => {
    const handleClose = () => {
        onClose && onClose()
    }

    return (
        <Container>
            <ButtonWrapper>
                <BackButton icon="pi pi-arrow-left" label="Vissza" onClick={handleClose} />
                {partnerName && <CurrentPartner partnerName={partnerName} backButton={false}></CurrentPartner>}
            </ButtonWrapper>
            <FormContainer>
                <FormContainerWrapper>{children}</FormContainerWrapper>
            </FormContainer>
        </Container>
    )
}
